import { get, post } from '@/api/apiService.ts';
import type {
  CreateFeedbackSurveyRequest,
  FeedbackSurveyAdminResults,
  FeedbackSurveyStatus,
} from '@/types/feedbackSurvey.ts';

const feedbackSurveyService = {
  getStatus(): Promise<FeedbackSurveyStatus> {
    return get<FeedbackSurveyStatus>('/api/feedback-survey/status');
  },
  submit(data: CreateFeedbackSurveyRequest): Promise<void> {
    return post<CreateFeedbackSurveyRequest, void>('/api/feedback-survey', data);
  },
  getAdminResults(): Promise<FeedbackSurveyAdminResults> {
    return get<FeedbackSurveyAdminResults>('/api/feedback-survey/admin');
  },
};

export default feedbackSurveyService;
